import { createResourceStore } from "@/lib/resource";
import type { Shop } from "./Shop";
import type { OhadaCode } from "./OhadaCode";

export interface FinanceCategory {
  id: string;
  title: string;
  type: string;
  description?: string | null;
  ohada_code_id: string;
  ohada_code: OhadaCode;
  shop_id: string;
  shop: Shop;
  payable_type: string;
}

export const useFinanceCategory =
  createResourceStore<FinanceCategory>("finance-categories");
